import { API_URL } from 'constants/routes';

import type { FacetedResponse, Response } from 'api_entities/types';
import { CancelTokenSource, fetcher } from 'api_entities/fetch';

import { City } from './types';

export const citiesApi = {
  getCityBySlug: async function (slug?: string) {
    const { data } = await fetcher.get<City>(`${API_URL.CITIES}/slug/${slug}`);
    return data;
  },
  getAllCities: async function () {
    const params = new URLSearchParams();
    params.append('limit', '1000');
    const { data } = await fetcher.get<string[]>(`${API_URL.CITIES}/site_map`, {
      params: params,
      headers: {
        'x-token-token': process.env.NEXT_PUBLIC_SITEMAP_TOKEN || '',
      },
    });
    return data;
  },
  getCities: async function (params: URLSearchParams, cancelToken?: CancelTokenSource) {
    const { data } = await fetcher.get<FacetedResponse<City>>(`${API_URL.CITIES}`, {
      params,
      cancelToken: cancelToken?.token || undefined,
    });
    return data;
  },
  getCitiesAndProvinces: async function () {
    const data = await Promise.all([
      fetcher.get<Response<string>>(API_URL.GENERAL_CITIES),
      fetcher.get<Response<string>>(API_URL.PROVINCES),
    ]);
    return data;
  },
  getProvinces: async function () {
    const { data } = await fetcher.get<Response<string>>(API_URL.PROVINCES);
    return data;
  },
};
